import React from 'react';
import dollars from '../../dollar-format';
import {dateISOtoUS} from '../../date-converter';
import imgSrc from 'arcdynamic-resize';
import {hscLogo, striveWhiteLogo} from "../../consts/consts";

const noPropertiesPerPage = 9;
const minNoPropertiesPerPage = 3;

function integer(value) {
    if (value === undefined || value === null || value === '') return '';
    return Math.round(Number(value)).toLocaleString();
}

function percent(value, withDecimals = true) {
    if (value === undefined || value === null || value === '') return '';
    if (withDecimals)
        return Number(value).toFixed(2) + '%';
    return parseInt(value) + '%';
}

const Print = (props) => {
    const {listings} = props;

    if (!listings) return null;

    const query = props.location.query;
    const isHSC = query.SOURCE === 'HSC';
    const isClosed = query.CLOSE_OF_ESCROW_MIN || query.CLOSE_OF_ESCROW_MAX || query.STATUS === 'Closed,' || query.HSC_STATUS === 'Closed,';
    let columns = [];

    if (isHSC) {
        columns.push({
            name: "Status",
            render: (el) => el.HSC_STATUS,
            average: false,
        }, {
            name: 'Property',
            render: (el) => {
                return (
                    <div>
                        <div><strong>{el.NAME}</strong></div>
                        <div>{el.ADDRESS}</div>
                        <div>{el.CITY}, {el.STATE} {el.ZIP}</div>
                    </div>
                )
            },
            average: false,
        }, {
            name: (
                <div>
                    <div>Price</div>
                    <div>Cap Rate</div>
                </div>
            ),
            render: (el) => {
                let price = el.HSC_PRICE;
                let capRate = el.CAPITALIZATION_RATE;

                if (el.HSC_STATUS && el.HSC_STATUS.includes('Closed')) {
                    price = el.SOLD_PRICE;
                    capRate = el.CLOSE_CAP_RATE;
                }

                return (
                    <div>
                        <div>{price == null || price === '' ? '-' : dollars(price)}</div>
                        <div>{capRate == null || capRate === '' ? '-' : percent(capRate)}</div>
                    </div>
                )
            },
            average: () => {
                const parts = [];
                let priceKey = '';
                let capRateKey = '';

                if (query.HSC_STATUS && query.HSC_STATUS.includes('Closed')) {
                    priceKey = 'SOLD_PRICE';
                    capRateKey = 'CLOSE_CAP_RATE';
                } else {
                    priceKey = 'HSC_PRICE';
                    capRateKey = 'CAPITALIZATION_RATE';
                }

                {
                    const list = listings.filter(x => x[priceKey]).map(x => parseFloat(x[priceKey]));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        parts.push(dollars(Math.round(sum / list.length)));
                    } else {
                        parts.push('-');
                    }
                }
                {
                    const list = listings.filter(x => x[capRateKey]).map(x => parseFloat(x[capRateKey]));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        parts.push(percent(sum / list.length));
                    } else {
                        parts.push('-');
                    }
                }
                return parts.map((x, i) => <div key={i}>{x}</div>);
            },
        }, {
            name: "Loan Amount",
            render: (el) => dollars(el.LOAN_AMOUNT),
            average: () => {
                const list = listings.filter(x => x.LOAN_AMOUNT).map(x => parseInt(x.LOAN_AMOUNT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return dollars(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "LTV",
            render: (el) => percent(el.LTV, false),
            average: () => {
                const list = listings.filter(x => x.LTV).map(x => parseFloat(x.LTV));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return percent(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "Down Payment",
            render: (el) => dollars(el.DOWN_PAYMENT),
            average: () => {
                const list = listings.filter(x => x.DOWN_PAYMENT).map(x => parseInt(x.DOWN_PAYMENT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return dollars(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "Rate",
            render: (el) => percent(el.INTEREST_RATE),
            average: () => {
                const list = listings.filter(x => x.INTEREST_RATE).map(x => parseFloat(x.INTEREST_RATE));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return percent(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "Amo",
            render: (el) => el.AMORTIZATION,
            average: false,
        }, {
            name: "Term",
            render: (el) => el.TERM,
            average: false,
        }, {
            name: "Lender",
            render: (el) => el.LENDER_NAME,
            average: false,
        });
    } else {
        columns.push({
            name: 'Status',
            render: (el) => el.STATUS,
            average: false,
        });

        if (isClosed) {
            columns.push({
                name: 'Close of Escrow',
                render: (el) => el.CLOSE_OF_ESCROW ? dateISOtoUS(el.CLOSE_OF_ESCROW) : '',
                average: false,
            });
        }

        columns.push(
            {
                name: 'Type',
                render: (el) => el.TYPE,
                average: false,
            },
            {
                name: 'Photo',
                render: (el) => {
                    if (el.PHOTOS) {
                        const files = el.PHOTOS.split(',').map(x => x.trim());
                        if (files.length) {
                            const src = imgSrc(arc.path.media + files[0], 100, 50);
                            return <img src={src} alt='' style={{display: 'block'}}/>
                        }
                    }
                    return null;
                },
                average: false,
            },
            {
                name: 'Property',
                render: (el) => {
                    return (
                        <div>
                            <div><strong>{el.NAME}</strong></div>
                            <div>{el.ADDRESS}</div>
                            <div>{el.CITY}, {el.STATE} {el.ZIP}</div>
                        </div>
                    )
                },
                average: false,
            },
            {
                name: (
                    <div>
                        <div>Price</div>
                        <div>Cap Rate</div>
                        <div>NOI</div>
                    </div>
                ),
                render: (el) => {
                    let price = '';
                    let capRate = '';
                    const noi = el.NET_OPERATING_INCOME;

                    if (el.STATUS && el.STATUS.includes('Closed')) {
                        price = el.SOLD_PRICE;
                        capRate = el.CLOSE_CAP_RATE;
                    } else if (el.STATUS && (el.STATUS.includes('In Negotiation') || el.STATUS.includes('Under Contract'))) {
                        price = el.NEGOTIATION_PRICE;
                        capRate = el.NEGOTIATION_CAP_RATE;
                    } else {
                        price = el.LIST_PRICE;
                        capRate = el.CAPITALIZATION_RATE;
                    }

                    return (
                        <div>
                            <div>{price == null || price === '' ? '-' : dollars(price)}</div>
                            <div>{capRate == null || capRate === '' ? '-' : percent(capRate)}</div>
                            <div>{noi == null || noi === '' ? '-' : dollars(noi)}</div>
                        </div>
                    )
                },
                average: () => {
                    const parts = [];
                    let priceKey = '';
                    let capRateKey = '';

                    if (query.STATUS && query.STATUS.includes('Closed')) {
                        priceKey = 'SOLD_PRICE';
                        capRateKey = 'CLOSE_CAP_RATE';
                    } else if (query.STATUS && (query.STATUS.includes('In Negotiation') || query.STATUS.includes('Under Contract'))) {
                        priceKey = 'NEGOTIATION_PRICE';
                        capRateKey = 'NEGOTIATION_CAP_RATE';
                    } else {
                        priceKey = 'LIST_PRICE';
                        capRateKey = 'CAPITALIZATION_RATE';
                    }

                    {
                        const list = listings.filter(x => x[priceKey]).map(x => parseFloat(x[priceKey]));
                        if (list.length) {
                            const sum = list.reduce((a, b) => a + b);
                            parts.push(dollars(Math.round(sum / list.length)));
                        } else {
                            parts.push('-');
                        }
                    }
                    {
                        const list = listings.filter(x => x[capRateKey]).map(x => parseFloat(x[capRateKey]));
                        if (list.length) {
                            const sum = list.reduce((a, b) => a + b);
                            parts.push(percent(sum / list.length));
                        } else {
                            parts.push('-');
                        }
                    }
                    {
                        const list = listings.filter(x => x.NET_OPERATING_INCOME).map(x => parseFloat(x.NET_OPERATING_INCOME));
                        if (list.length) {
                            const sum = list.reduce((a, b) => a + b);
                            parts.push(dollars(Math.round(sum / list.length)));
                        } else {
                            parts.push('-');
                        }
                    }
                    return parts.map((x, i) => <div key={i}>{x}</div>);
                },
            },
        );

        columns.push({
            name: 'SQFT',
            render: (el) => integer(el.SQFT),
            average: () => {
                const list = listings.filter(x => x.SQFT).map(x => parseFloat(x.SQFT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return integer(sum / list.length);
                } else {
                    return null;
                }
            },
        }, {
            name: 'Rent/SQFT',
            render: (el) => dollars(el.RENT_PER_SQFT, true),
            average: () => {
                const list = listings.filter(x => x.RENT_PER_SQFT).map(x => parseFloat(x.RENT_PER_SQFT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return dollars(sum / list.length);
                } else {
                    return null;
                }
            },
        });

        if (isClosed) {
            columns.push({
                name: 'Close PSF',
                render: (el) => dollars(el.CLOSE_PRICE_PER_SQFT),
                average: () => {
                    const list = listings.filter(x => x.CLOSE_PRICE_PER_SQFT).map(x => parseFloat(x.CLOSE_PRICE_PER_SQFT));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return dollars(sum / list.length);
                    } else {
                        return null;
                    }
                },
            });
        } else {
            columns.push({
                name: 'PSF',
                render: (el) => dollars(el.PRICE_PER_SQFT),
                average: () => {
                    const list = listings.filter(x => x.PRICE_PER_SQFT).map(x => parseFloat(x.PRICE_PER_SQFT));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return dollars(sum / list.length);
                    } else {
                        return null;
                    }
                },
            });
        }

        columns.push({
            name: <span>Year<br/>Built</span>,
            render: (el) => el.YEAR_BUILT,
            average: () => {
                const list = listings.filter(x => x.YEAR_BUILT).map(x => parseFloat(x.YEAR_BUILT));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return Math.round(sum / list.length);
                } else {
                    return null;
                }
            },
        }, {
            name: 'Occupancy',
            render: (el) => percent(el.VACANCY, true),
            average: () => {
                const list = listings.filter(x => x.VACANCY).map(x => parseFloat(x.VACANCY));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return percent(sum / list.length);
                } else {
                    return null;
                }
            },
        }, {
            name: <span>Remaining<br/>Term</span>,
            render: (el) => {
                if (el.LEASE_EXPIRATION_DATE && el.CLOSE_OF_ESCROW) {
                    const leaseExpiration = new Date(el.LEASE_EXPIRATION_DATE);
                    const closeOfEscrow = new Date(el.CLOSE_OF_ESCROW);
                    const diff = leaseExpiration - closeOfEscrow;

                    if (diff !== diff) {
                        // NaN
                        return '';
                    }

                    if (diff <= 0) {
                        return 'Expired';
                    }

                    return Math.round(diff / (1000 * 60 * 60 * 24 * 365) * 2) / 2;
                }

                return '';
            },
            average: true,
        });
    }

    function renderPage({data, isLastPage, pageNo, totalPages}) {
        return (
            <React.Fragment>
                <div className='Print_head'>
                    <div className={`Print_head_logo ${isHSC ? 'hsc' : ''}`}>
                        <img src={arc.path.media + (isHSC ? hscLogo : striveWhiteLogo)} alt=''/>
                    </div>
                </div>
                <div className='Print_body'>
                    <table>
                        <thead>
                        <tr>
                            {
                                columns.map((col, i) => <th key={i}>{col.name}</th>)
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            data.map(x => (
                                <tr key={x.ARCIMEDES_ROW_ID}>
                                    {
                                        columns.map((col, i) => <td key={i}>{col.render(x)}</td>)
                                    }
                                </tr>
                            ))
                        }
                        </tbody>
                        <tfoot style={{display: isLastPage ? '' : 'none'}}>
                        <tr>
                            {
                                (() => {
                                    let colspan = 0;

                                    columns.every(x => {
                                        if (x.average === false) {
                                            colspan++;
                                            return true;
                                        }
                                    });

                                    return [<td key='x' colSpan={colspan}>Average:</td>].concat(columns.slice(colspan).map((col, i) => (
                                        <td key={i}>{typeof col.average === 'function' ? col.average() : null}</td>
                                    )))
                                })()
                            }
                        </tr>
                        </tfoot>
                    </table>
                </div>
                <div className='Print_footer'>
                    {
                        isHSC ?
                            '(469) 998-7200 | 5550 LBJ Fwy Suite 815 Dallas, TX 75240 | www.highstcapital.com'
                            :
                            '(469) 844-8880 | 5550 LBJ Fwy Suite 800 Dallas, TX | www.StriveRE.com'
                    }
                    <span className='pagination'>{pageNo}/{totalPages}</span>
                </div>
            </React.Fragment>
        )
    }

    let pageIndex = 0;
    let noTables = Math.ceil(listings.length / noPropertiesPerPage);
    const remainingProperties = listings.length % noPropertiesPerPage;
    const hasRemainingProperties = remainingProperties < minNoPropertiesPerPage;
    // if the remainder is 0 another table is needed
    if (!remainingProperties) noTables++;

    return (
        <div className='Print'>
            {
                [...Array(noTables)].map((value, index) => {
                    const isLastPage = index === noTables - 1;
                    const isSecondToLastPage = index === noTables - 2;

                    let lastPageIndex = pageIndex + noPropertiesPerPage;
                    if (hasRemainingProperties && isSecondToLastPage) {
                        lastPageIndex = pageIndex + noPropertiesPerPage - (minNoPropertiesPerPage - remainingProperties);
                    }

                    const data = listings.slice(pageIndex, lastPageIndex);

                    if (hasRemainingProperties && isSecondToLastPage) {
                        pageIndex += noPropertiesPerPage - (minNoPropertiesPerPage - remainingProperties);
                    } else {
                        pageIndex += noPropertiesPerPage;
                    }

                    return (
                        <div key={index} className='print-container'>
                            {renderPage({data, isLastPage, pageNo: index + 1, totalPages: noTables})}
                        </div>
                    )
                })
            }
        </div>
    );
};

export default Print;
